const words = ["Leitura de Tarot", "Via WhatsApp", "Pix com confirmação imediata", "Sigilo absoluto", "Arcanos Maiores & Menores", "Mãos Arcana"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-16 pr-16 md:gap-24 md:pr-24">
    {words.map((w) => (
      <span key={w} className="flex items-center gap-16 md:gap-24">
        <span className="font-display whitespace-nowrap text-4xl italic text-[#CBA365]/85 md:text-6xl">{w}</span>
        <span className="text-xl text-[#6D28D9]">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0d0519] py-8 md:py-10">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </div>
);
